import React from 'react';
import SVGLoader, {
  SVGLoaderProps,
} from '@rsos/base-assets/icons/src/SVGLoader';

const defaults = {
  width: 16,
  height: 16,
  viewboxWidth: 16,
  viewboxHeight: 16,
};

export const ArchiveBoxUpIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}: SVGLoaderProps) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0.666672H15C15.5333 0.666672 16 1.13334 16 1.66667V3.50001C16 3.67682 15.9298 3.84639 15.8047 3.97141C15.6797 4.09643 15.5101 4.16667 15.3333 4.16667H0.666667C0.489856 4.16667 0.320286 4.09643 0.195262 3.97141C0.0702379 3.84639 0 3.67682 0 3.50001V1.66667C0 1.13334 0.466667 0.666672 1 0.666672ZM1.46667 5.33334C1.33406 5.33334 1.20688 5.38602 1.11311 5.47979C1.01935 5.57355 0.966667 5.70073 0.966667 5.83334V12.8333C0.966667 14.2427 2.05733 15.3333 3.46667 15.3333H12.5333C13.9427 15.3333 15.0333 14.2427 15.0333 12.8333V5.83334C15.0333 5.70073 14.9807 5.57355 14.8869 5.47979C14.7931 5.38602 14.6659 5.33334 14.5333 5.33334H1.46667ZM8 7.33334L10.3333 9.66667H8.83333V12.6667H7.16667V9.66667H5.66667L8 7.33334Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default ArchiveBoxUpIcon;
